import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ReadMoreIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 52.811 47.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.5),
    children: /*#__PURE__*/jsx("path", {
      d: "M1.25 1.25h50.311M1.25 11.312h50.311M1.25 21.374h50.311M35.07 39.542l6.708 6.708 6.708-6.708M41.782 46.25V27.803M31.776 31.436H1.25M1.25 41.498h16.77"
    })
  });
};

export { PM2ReadMoreIcon };
//# sourceMappingURL=read-more.js.map
